import React, { FC, useEffect, useState } from "react";
import { useAdministratorStore } from "../../hooks/useAdministratorStore";
import { company } from "../../types/slices/companyType";
import { CustomSnackbar } from "../../components/common/CustomSnackbar/CustomSnackbar";
import { Autocomplete, CircularProgress, Divider, FormLabel, Grid, TextField } from "@mui/material";
import { ModalHeader } from "../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../components/common/Modal/ModalBody";
import { Formik } from "formik";
import { ModalFooter } from "../../components/common/Modal/ModalFooter";
import { ApiStatus } from "../../types/api/status";
import { Modal } from "../../components/common/Modal/Modal";
import { useCompanyStore } from "../../hooks/useCompanyStore";

type ValuesForm = {
    rut: string
    name: string
    surname: string
    email: string
    address: string
    phone: string
    username: string
    idsCompany: number[]
}

export const AdministratorModal: FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, onList, action } = props

    const { status: statusCompany, companies, getCompanies } = useCompanyStore()
    const { status, adminSelected, createAdmin, updateAdmin } = useAdministratorStore()

    const [companySelected, setCompanySelected] = useState<company[]>([])
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const data: ValuesForm = {
        rut: adminSelected ? adminSelected.rut : '',
        name: adminSelected ? adminSelected.name : '',
        surname: adminSelected ? adminSelected.surname : '',
        email: adminSelected ? adminSelected.email : '',
        address: adminSelected ? adminSelected.surname : '',
        phone: adminSelected ? adminSelected.phone : '',
        username: adminSelected ? adminSelected.username : '',
        idsCompany: adminSelected?.idsCompany ?? []
    }

    useEffect(() => {
        getCompanies()
    }, [])

    useEffect(() => {
        if (action === 'edit') {
            setIsEdit(true)
        }
    }, [action])

    useEffect(() => {
        if (action !== 'create' && adminSelected.idsCompany?.length > 0) {
            const data = companies.filter(company =>
                adminSelected.idsCompany.includes(company.id)
            )
            setCompanySelected(data || null)
        }
    }, [companies])


    const validateForm = (values) => {
        let errors: any = {};

        if (!values.rut) errors.rut = "el campo es requerido";
        if (!values.name) errors.name = "el campo es requerido";
        if (!values.surname) errors.surname = "el campo es requerido";
        if (!values.email) errors.email = "el campo es requerido";
        if (action == 'create' && !values.username) errors.username = "el campo es requerido";

        return errors;
    }

    const onSubmit = async (values) => {
        if (companySelected.length == 0) return CustomSnackbar('warning', 'Seleccione una empresa')

        let payload: any = {
            rut: values.rut,
            name: values.name,
            surname: values.surname,
            email: values.email,
            address: values.address,
            phone: values.phone,
            idsCompany: companySelected.map(company => company.id)
        }
        if (action === 'create') payload = { ...payload, username: values.username }

        const response = await (action === 'create' ? createAdmin(payload) : updateAdmin(adminSelected.id, payload))
        if (response === true) {
            onList()
            closeModal()
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{ style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' } }}>
            <ModalHeader
                text={action === 'detail' ? 'Detalle del administrador ' : (isEdit ? 'Editar administrador' : 'Nuevo administrador')}
                className='positionElements'
                onCancel={closeModal}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={(values) => validateForm(values)} onSubmit={onSubmit}>
                    {({ values, errors, touched, handleSubmit, handleChange, setFieldValue }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{ padding: '20px' }}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12}>
                                            <FormLabel>{'Nombre(s):'}</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text"
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                                InputProps={{
                                                    readOnly: action === 'detail',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormLabel>{'Apellido(s):'}</FormLabel>
                                            <TextField
                                                id="surname"
                                                type="text"
                                                name="surname"
                                                fullWidth
                                                size="small"
                                                value={values.surname}
                                                onChange={handleChange}
                                                error={errors.surname && touched.surname ? true : false}
                                                helperText={errors.surname && touched.surname ? errors.surname : ''}
                                                InputProps={{
                                                    readOnly: action === 'detail',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormLabel>RUT:</FormLabel>
                                            <TextField
                                                id="rut"
                                                type="text"
                                                name="rut"
                                                fullWidth
                                                size="small"
                                                value={values.rut}
                                                onChange={handleChange}
                                                error={errors.rut && touched.rut ? true : false}
                                                helperText={errors.rut && touched.rut ? errors.rut : ''}
                                                InputProps={{
                                                    inputProps: {
                                                        maxLength: 10
                                                    },
                                                    readOnly: action === 'detail',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormLabel>Email:</FormLabel>
                                            <TextField
                                                id="email"
                                                type="email"
                                                name="email"
                                                fullWidth
                                                size="small"
                                                value={values.email}
                                                onChange={handleChange}
                                                error={errors.email && touched.email ? true : false}
                                                helperText={errors.email && touched.email ? errors.email : ''}
                                                InputProps={{
                                                    readOnly: action === 'detail',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormLabel>Celular:</FormLabel>
                                            <TextField
                                                id="phone"
                                                type="text"
                                                name="phone"
                                                fullWidth
                                                size="small"
                                                value={values.phone}
                                                onChange={handleChange}
                                                InputProps={{
                                                    inputProps: {
                                                        pattern: "[1-9]*",
                                                        maxLength: 10
                                                    },
                                                    readOnly: action === 'detail',
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormLabel>Direccion:</FormLabel>
                                            <TextField
                                                id="address"
                                                type="text"
                                                name="address"
                                                fullWidth
                                                size="small"
                                                value={values.address}
                                                onChange={handleChange}
                                                InputProps={{
                                                    readOnly: action === 'detail',
                                                }}
                                            />
                                        </Grid>
                                        {action === 'create' && <Grid item xs={12}>
                                            <FormLabel>Username:</FormLabel>
                                            <TextField
                                                id="username"
                                                type="text"
                                                name="username"
                                                fullWidth
                                                size="small"
                                                value={values.username}
                                                onChange={handleChange}
                                                error={errors.username && touched.username ? true : false}
                                                helperText={errors.username && touched.username ? errors.username : ''}
                                                InputProps={{
                                                    readOnly: action === 'detail',
                                                }}
                                            />
                                        </Grid>}
                                        <Grid item xs={12}>
                                            <FormLabel>Empresa:</FormLabel>
                                            <Autocomplete
                                                disablePortal
                                                multiple
                                                id="combo-box-company"
                                                value={companySelected}
                                                options={statusCompany === ApiStatus.FETCHING ? [] : companies}
                                                getOptionLabel={(option) => option.business_name || ""}
                                                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                                fullWidth
                                                renderInput={(params) =>
                                                    <TextField {...params} size="small"
                                                        InputProps={{
                                                            ...params.InputProps,
                                                            endAdornment: (
                                                                <React.Fragment>
                                                                    {statusCompany === ApiStatus.FETCHING && <CircularProgress color="inherit" size={20} />}
                                                                    {params.InputProps.endAdornment}
                                                                </React.Fragment>
                                                            ),
                                                        }}
                                                    />
                                                }
                                                onChange={(e, newValue) => {
                                                    setCompanySelected(newValue);
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action !== 'detail' &&
                                    <ModalFooter
                                        buttonType="submit"
                                        confirmText={'Guardar'}
                                        onConfirm={handleSubmit}
                                        cancelText={"Cancelar"}
                                        onCancel={closeModal}
                                        loadingConfirmText={status === ApiStatus.FETCHING}
                                    />
                                }
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
    )
}